import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';

export type CountryByIdData = AnyObject

export type CountryByIdResponse = CountryByIdData

export interface CountryById {
  id: number;
}

export const countryById = (payload: CountryById): Action<CountryById> => ({
  type: actions.countryByIdTrigger.toString(),
  payload,
});

export const countryByIdClear = (): Action => ({
  type: actions.countryByIdClear.toString(),
});

export function* countryByIdRequestSaga({ payload }: Action<CountryById>) {
  yield put({
    type: actions.countryByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.countryByIdError.toString(),
      payload: {
        message: 'CountryById: Parameters not passed.',
      },
    });

    return;
  }

  const { id, ...params } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${config.api.url}admin/countries/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        params: new URLSearchParams(params).toString(),
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<CountryByIdData, CountryByIdResponse>(
    response,
    actions.countryByIdSuccess.toString(),
    actions.countryByIdError.toString(),
    false,
    (countryByIdData) => countryByIdData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.countryByIdTrigger.toString(),
    defaultProcessingSaga(
      countryByIdRequestSaga,
      {
        error: actions.countryByIdError.toString(),
        locationCancel: actions.countryByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.countryByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.countryByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.countryByIdErrorReset.toString(),
    });
  });
}
